import { DndContext, useSensor, useSensors, PointerSensor, closestCenter } from "@dnd-kit/core";
import { SortableContext, arrayMove } from "@dnd-kit/sortable";
import ImageGridItem from "./ImageGridItem";
import MultiImageUploader from "../../../../form/MultiImageUploader";
import { classNames } from "../../../../../helpers/classNames";

const SortableImageGrid = ({ isMulti = true, hideImageUpload = false, images, setImages, onEdit, handleImageUpload, onDeleteImage, onDragEnd = () => { }, isSingleCover, uploadingImages = [], uploadingNewImages = [] }) => {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8, // Only start dragging after 8px move
      },
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;

    // Early return if no drop target
    if (!over) return;

    const activeId = active.id ?? active._id;
    const overId = over.id ?? over._id;

    if (activeId !== overId) {
      const oldIndex = images.findIndex((i) => (i.id ?? i._id) === activeId);
      const newIndex = images.findIndex((i) => (i.id ?? i._id) === overId);

      if (oldIndex !== -1 && newIndex !== -1) {
        const updated = arrayMove(images, oldIndex, newIndex);
        setImages(updated);
        onDragEnd(updated);
      }
    }
  };

  const handleDelete = (id) => {
    onDeleteImage?.(id);
  };

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext items={images.map((img) => img.id ?? img._id)}>
        <div className="flex flex-wrap items-start justify-center gap-2 md:gap-3">
          {images.map((image, index) => (
            <div
              key={index}
              className={classNames(
                "",
                (images.length % 2 !== 0 && index === images.length - 1) ? "" : "w-24 md:w-28"
              )}
            >
              <ImageGridItem
               key={index} image={image} index={index} onClick={() => onEdit(image)} onDelete={handleDelete} isSingleCover={isSingleCover} uploadingImages={uploadingImages} uploadingNewImage={!!image.id && uploadingNewImages.includes(image.id)} 
              />
            </div>
          ))}
          {/* {isMulti && !hideImageUpload && (
            <div className="relative w-24 md:w-28 aspect-[8/11] flex">
              <MultiImageUploader
                key={`mini-uploader-${images.length}-${Date.now()}`}
                isMini={true}
                onChange={handleImageUpload}
                values={[]} // Always start with empty values
              />
            </div>
          )} */}
        </div>
      </SortableContext>
    </DndContext>
  );
};

export default SortableImageGrid;
